export default {
  title: 'Expenses',
  totals: {
    including_vat: 'Total (including VAT)',
    excluding_vat: 'Total (excluding VAT)',
  },
  labels: {
    date: 'Expense Date',
    category: 'Category',
    amount: 'Amount',
    vat_amount: 'VAT Amount',
    transaction_fee: 'Transaction Fee',
    total_amount: 'Total Amount',
    vendor_name: 'Vendor',
    vendor: 'Vendor',
    description: 'Description',
    payment_method: 'Payment Method',
    notes: 'Notes',
    property: 'Property',
    receipt: 'Receipt',
    receipt_images: 'Receipt / Tax Invoice',
    evidence_images: 'Supporting Photos',
    wht_rate: 'Withholding Tax Rate',
    wht_amount: 'WHT Amount',
    net_cash_amount: 'Net Cash Amount',
    created_by: 'Created By',
    status: 'Status',
    paid_by: 'Paid By',
    approved_by: 'Approved By',
    reimbursed_at: 'Reimbursed At',
    maintenance_request: 'Linked Maintenance',
    reconciled: 'Reconciled',
    not_reconciled: 'Not reconciled',
    lease: 'Lease',
    unit: 'Room',
  },
  placeholders: {
    vendor_name: 'Enter vendor name',
    description: 'Enter description',
    notes: 'Additional notes',
    paid_by: 'Name of person who paid',
    transaction_fee: 'e.g. bank transfer fee',
    search: 'Search vendor or description...',
    search_vendor: 'Search vendor...',
    wht_rate_custom: 'e.g. 0.025',
  },
  wht_presets: {
    none: 'None',
    rate_1: '1%',
    rate_1_5: '1.5%',
    rate_2: '2%',
    rate_3: '3%',
    rate_5: '5%',
    rate_10: '10%',
    custom: 'Custom',
  },
  sections: {
    reconciliation: 'Bank Reconciliation',
    withholding_tax: 'Withholding Tax (WHT)',
    evidence: 'Attachments',
  },
  lease_chip: {
    linked_to: 'Linked to lease {{leaseCode}} · Room {{unitNumber}}',
    view_lease: 'View lease',
  },
  messages_detail: {
    no_attachments: 'No attachments',
  },
  messages: {
    delete_confirm: 'Are you sure you want to delete this expense?',
    delete_success: 'Expense deleted successfully',
    create_success: 'Expense created successfully',
    update_success: 'Expense updated successfully',
    reimburse_confirm: 'Approve reimbursement for this expense?',
    reimburse_success: 'Reimbursement approved',
    complete_confirm: 'Mark reimbursement as completed?',
    complete_success: 'Expense marked as completed',
    confirm_expense_confirm: 'Confirm this expense?',
    confirm_expense_success: 'Expense confirmed',
    no_wht_template: 'No WHT certificate template found. Please configure one in Settings → Templates.',
    no_reimbursement_template: 'No reimbursement receipt template found. Please configure one in Settings → Templates.',
  },
  actions: {
    new_expense: 'New Expense',
    edit_expense: 'Edit Expense',
    reimburse: 'Approve Reimbursement',
    mark_complete: 'Mark Complete',
    confirm_expense: 'Confirm Expense',
    export_csv: 'Export CSV',
    create_vendor: 'Create New Vendor',
    enter_manually: 'Or enter manually',
    generate_wht_certificate: 'Generate 50 ทวิ',
    download_reimbursement_receipt: 'Download Receipt',
  },
  empty: {
    title: 'No expenses yet',
    description: 'Start tracking your property expenses',
  },
  statuses: {
    completed: 'Completed',
    pending_reimbursement_approval: 'Pending Reimbursement',
    reimbursement_approved: 'Reimbursement Approved',
    pending_confirmation: 'Pending Confirmation',
  },
  payment_methods: {
    cash: 'Cash',
    bank_transfer: 'Bank Transfer',
    cheque: 'Cheque',
    credit_card: 'Credit Card',
    direct_debit: 'Direct Debit',
    other: 'Other',
  },
  categories: {
    repairs: 'Repairs & Maintenance',
    utilities: 'Utilities (Common Area)',
    insurance: 'Insurance',
    property_tax: 'Property Tax',
    labor: 'Labor',
    supplies: 'Supplies',
    cleaning: 'Cleaning',
    security: 'Security',
    management_fee: 'Management Fee',
    office_equipment: 'Office Equipment',
    other: 'Other',
    deposit_return: 'Deposit Return',
    // EP-156 (T156-009/T156-010, §3.3) — the one expense POST /api/leases/:id/end
    // may create: the sum of the move-in fee and/or the key-card deposit.
    move_in_refund: 'Move-in Fee / Key-card Deposit Refund',
  },
  setup_guide: {
    title: 'Track Property Expenses',
    description: 'Record and categorize expenses across your properties. Track vendor payments, manage reimbursements, and generate financial reports.',
    prerequisites_title: 'Before you start',
    prereq_property: 'At least one property created',
    prereq_setup_property: 'Create Property',
    step_1_title: 'Record an Expense',
    step_1_description: 'Add your first expense with category, amount, and vendor details.',
    step_2_title: 'Categorize & Track',
    step_2_description: 'Use categories to organize expenses and track spending patterns.',
    step_3_title: 'Review Reports',
    step_3_description: 'View expense summaries, trends, and profit & loss reports.',
  },
  filters: {
    all_statuses: 'All Statuses',
    all_categories: 'All Categories',
    date_from: 'From',
    date_to: 'To',
    missing_receipt: 'Missing receipt',
    has_wht: 'Has WHT',
  },

  errors: {
    validation_failed: 'Validation failed. Please check the form and try again.',

    fields: {
      property_id: 'Property',
      category: 'Category',
      amount: 'Amount',
      vat_amount: 'VAT amount',
      transaction_fee: 'Transaction fee',
      expense_date: 'Expense date',
      vendor_name: 'Vendor',
      payment_method: 'Payment method',
    },

    codes: {
      blank: "can't be blank",
      taken: 'is already taken',
      invalid: 'is invalid',
      too_short: 'is too short',
      too_long: 'is too long',
      greater_than: 'must be greater than the limit',
      greater_than_or_equal_to: 'must be greater than or equal to the limit',
      less_than: 'must be less than the limit',
      less_than_or_equal_to: 'must be less than or equal to the limit',
      not_a_number: 'is not a number',
      inclusion: 'is not included in the list',
    },
  },
}
